/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { CatalogEntryRecommendation } from '@/components/content/CatalogEntryRecommendation';
import { CategoryRecommendation } from '@/components/content/CategoryRecommendation';
import { ContentCarousel } from '@/components/content/ContentCarousel';
import { ContentRecommendation, ContentRecommendationSkeleton } from '@/components/content/ContentRecommendation';
import { useEMarketingSpot } from '@/data/Content/EMarketingSpot';
import { ID } from '@/data/types/Basic';
import { WidgetProperties } from '@/data/types/Slot';
import { Stack } from '@mui/material';
import { FC } from 'react';

const emptyProperties = {} as WidgetProperties;

export const EMarketingSpot: FC<{ id: ID; properties?: WidgetProperties }> = ({
	id,
	properties = emptyProperties,
}) => {
	const { emsName = '' } = properties;
	const { data, loading } = useEMarketingSpot(emsName);
	if (!loading && !data.hasContent && !data.hasCategory && !data.hasCatEntry) {
		return null;
	}
	return loading ? (
		<ContentRecommendationSkeleton />
	) : (
		<Stack>
			{data.hasContent ? (
				data.hasContentCarousel ? (
					<ContentCarousel id={id} properties={properties} />
				) : (
					<ContentRecommendation id={id} properties={properties} />
				)
			) : null}
			{data.hasCategory ? <CategoryRecommendation id={id} properties={properties} /> : null}
			{data.hasCatEntry ? <CatalogEntryRecommendation id={id} properties={properties} /> : null}
		</Stack>
	);
};
